<template>
  <FimButton to="/" type="primary">
    {{ $t('basket.return_to_shopping_label') }}
  </FimButton>
</template>
